;
define("product_views_option_percent.tpl", function(){});

